// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"357":"8f7549b2","420":"0186b628","453":"2a4c86c5"}[chunkId] + ".chunk.js";
};